<template>
  <div id="Invoice">
    <div class="topBtns">
      <div class="closeBtn">
        <b-button class="btnInvoice" @click="$bvModal.hide('modal-invoice-500')">CLOSE</b-button>
      </div>
      <div class="printBtn">
        <a @click="print">PRINT</a>
      </div>
    </div>
    <div class="header">
      <img src="@/assets/images/rays-logo.jpg" alt="Logo" />
      <h1><span>2021 RAYS</span> SEASON MEMBERSHIP AGREEMENT</h1>
    </div>

    <div class="account">
      <div class="userInfo">
        <div class="userField">
          {{name}}
        </div>
        <div class="userField">
          {{address1}} {{address2}}
        </div>
        <div class="userField">
          {{city}}, {{state}} {{zip}}
        </div>
      </div>
      <div class="accountNum">
        Acct. # <div class="userField inline">{{accountId}}</div>
      </div>
      <div class="raysInfo">
        <h3>Tampa Bay Rays</h3>
        <p>P.O. Box 15758</p>
        <p>St. Petersburg, FL 33733</p>
        <p><span>p:</span> 727.825.3250</p>
        <p><span>e:</span> seasonticketservices@raysbaseball.com</p>
      </div>
    </div>

    <div class="membership">
      <h2>2021 RAYS SEASON MEMBERSHIP</h2>
      <div class="membershipBox">
        <div>
           <span>Membership Level:</span> <div class="userField inline">$500</div>
        </div>
        <div>
           <span>Account Credit:</span> <div class="userField inline">{{credit}}</div>
        </div>
        <div>
           <span>Balance Due:</span> <div class="userField inline">{{due}}</div>
        </div>
      </div>
    </div>

    <div class="moreInfo">
      <div class="moreInfoLeft">
        <div class="blueLine">
          <p>Season Membership payments are non-refundable. By submitting payment I acknowledge that I have received a copy of the Tampa Bay Rays Season Member Policies and Procedures <a target="_blank" href="http://raysbaseball.com/policiesandprocedures">raysbaseball.com/policiesandprocedures</a>. I agree to be bound by the terms and conditions thereof. ACH/EFT payments and Debit Cards are not accepted.</p>
        </div>
        <div class="paymentHeader">
          <h2>PAYMENT</h2>
          <p><span>Choose one of the two payment options below</span> by checking the small box in the bottom right corner. Submit the invoice via mail or scan and email.</p>
        </div>
      </div>
      <div class="moreInfoRight">
        <p>If the credit on your account is greater than your Membership Level, you may use this additional credit to purchase game tickets at any time during the 2021 season. You may also choose to upgrade to the next Membership Level.</p>
      </div>
    </div>

    <div class="paymentPlan">
      <div class="paymentPlanLeft">
        <div class="paymentPlanLeft-top">
          <div>
            <h4>MONTHLY PAYMENT PLAN - INTEREST FREE FOR 2 MONTHS</h4>
            <p>
              You authorize the Rays to automatically withdraw from your credit card in 2 payments for a
              total of <span class="userField inline">$500</span>. After placing 50% down you will be
              charged <span class="userField inline">$250</span> according to the dates listed here.
              Any credits on your account will be applied toward your payment plan installments
              when they are processed beginning with your first payment. Any amounts not covered by your
              account credit at the time of processing will be covered by your specified payment method.
            </p>
            <p><span>
                Game tickets will be made available before Opening Day through the Ballpark app or
                online at raysbaseball.com/myaccount. You will be notified via email when games are
                available for selection. Please note, the credit on your account will become available
                once you have paid 50% of your account balance.
            </span></p>
          </div>
          <div>
            <h4>PAYMENT SCHEDULE</h4>
            <ol>
              <li>Upon Receipt</li>
              <li>May 10, 2021</li>
            </ol>
          </div>
        </div>
        <p>By selecting this option you authorize the Rays to automatically charge your credit card per the terms and conditions of this agreement. You agree that no prior notification will be provided unless the date or amount of the payment changes in which case notice will be provided 10 days in advance of the payment. You understand that if you cancel this authorization such cancellation does not relieve you of your payment obligations under this agreement (please contact your financial institution regarding this right to cancel automatic payments). This constitutes your copy of recurring payment authorization to the Rays. Please retain a copy for your records.</p>
        <div class="checkBox">
          <img src="@/assets/images/arrow.jpg" />
        </div>
      </div>
      <div class="paymentPlanRight">
        <h4>2021<br />FULL PAYMENT</h4>
        <div class="userField inline">{{due}}</div>
        <div class="due">Due Now</div>
        <div class="checkBox">
          <img src="@/assets/images/arrow.jpg" />
        </div>
      </div>
    </div>

    <div class="paymentOptions">
      <div class="paymentOptionsLeft">
        <div class="paymentRow">
          <div class="paymentOptionBox">
            <div></div>
            MasterCard
          </div>
          <div class="paymentOptionBox">
            <div></div>
            Visa
          </div>
          <div class="paymentOptionBox">
            <div></div>
            Discover
          </div>
          <div class="paymentOptionBox">
            <div></div>
            Amex
          </div>
          <div class="paymentOptionBox">
            <div></div>
            Check
          </div>
        </div>
        <div class="paymentRow paymentRowFields">
          <div class="creditCardInfo">
            <div class="creditCardInfoTop">
              <div class="userField"></div>
              Credit Card #
            </div>
            <div class="creditCardInfoBottom">
              <div>
                <div class="userField"></div>
                Exp. Date
              </div>
              <div>
                <div class="userField"></div>
                CVC
              </div>
            </div>
          </div>

          <div class="signature">
            <div class="signatureTop">
              <div class="userField"></div>
              Signature <span>(REQUIRED FOR ALL FORMS OF PAYMENT)</span>
            </div>
            <div class="signatureBottom">
              <div>
                <div class="userField"></div>
                Billing Zip Code
              </div>
              <div>
                <div class="userField"></div>
                Today's Date
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="paymentOptionsRight">
        <h2>RAYS TICKET ASSURANCE</h2>
        <p>We look forward to welcoming our Season Member family back to Tropicana Field in 2021. Rest assured that if you have tickets for games that are canceled or postponed due to COVID-19, you will receive the value of impacted games as a credit to your account for future ticket purchases or a refund to your original method of payment.</p>
      </div>
    </div>

    <div class="finePrint">
      The terms and conditions of your ticket purchase have been updated to address circumstances related to COVID-19, <a href="https://www.mlb.com/rays/tickets/disclaimer" target="_blank">Read them here.</a> By placing an order, you accept all terms and conditions applicable to ticket purchase, including these updated terms. 
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Invoice",
  
  data() {
    return {
      name: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      zip: null,
      accountId: null,
      credit: null,
      due: null,
      totalPayment: null
    };
  },
  created(){
    let userInfo = this.$store.state.global.userInfo;
    
    this.name = userInfo.financialFormatName
    this.address1 = userInfo.address1
    this.address2 = userInfo.address2
    this.city = userInfo.city
    this.state = userInfo.state
    this.zip = userInfo.zip
    this.accountId = userInfo.accountId
    this.credit = userInfo.totalCredit
    this.due = userInfo.balance500
    this.totalPayment = userInfo.balance500
  },
  computed: {
    ...mapState(["global"])
  },
  methods: {
    print() {
      this.$htmlToPaper("modal-invoice-500___BV_modal_body_");
    }
  },
}

</script>

<style lang="scss" scoped>
#Invoice {
  font-family: 'UniversLTStd';
  .topBtns {
    display: flex;
    margin-bottom: 25px;
    .closeBtn {
      button {
        background-color: #da3e3e !important;
        font-size: 12px;
      }
    }
    .printBtn {
      a {
        color: #fff;
        background-color: #43ba3d !important;
        font-size: 12px;
        cursor: pointer;
        padding: 10px 15px;
        border-radius: 4px;
        position: relative;
        top: 3px;
        left: 10px;
      }
    }
  }
  .userField {
    background-color: #f1f4ff;
    padding: 3px 5px;
    margin-bottom: 12px;
    font-size: 14px;
    &.inline {
      display: inline;
      margin: 0;
      border-bottom: 1px solid #000;
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid $light-blue;
    padding-bottom: 20px;
    @media only screen and (max-width: $lg) {
      flex-direction: column;
    }
    img {
      @media only screen and (max-width: $lg) {
        width: 100px;
      }
    }
    h1 {
      font-size: 24px;
      color: $dark-blue;
      position: relative;
      top: 10px;
      span {
        font-family: 'UniversLTStd-BoldCn';
      }
    }
  }
  .account {
    display: flex;
    justify-content: space-between;
    margin: 30px 0;
    @media only screen and (max-width: $lg) {
      flex-direction: column;
    }
    .userInfo {
      width: 40%;
    }
    .raysInfo {
      text-align: right;
      @media only screen and (max-width: $lg) {
        text-align: left;
        margin-top: 25px;
      }
      h3 {
        font-family: 'UniversLTStd-Bold';
        color: $dark-blue;
        font-size: 18px;
      }
      span {
        color: $dark-blue;
      }
      p {
        @media only screen and (max-width: $xl) {
          font-size: 14px;
        }
      }
    }
  }
  .membership {
    h2 {
      background-color: $dark-blue;
      color: #fff;
      font-family: 'UniversLTStd-Bold';
      font-size: 18px;
      text-align: center;
      padding: 5px 0;
      width: 400px;
      margin: 10px 0;
    }
    .membershipBox {
      padding: 25px 50px;
      border: 2px solid #bcbec0;
      display: flex;
      justify-content: space-between;
      @media only screen and (max-width: $lg) {
        flex-direction: column;
      }
      span {
        color: $dark-blue;
        font-family: 'UniversLTStd-Bold';
        font-size: 18px;
        @media only screen and (max-width: $xl) {
          font-size: 14px;
        }
      }
    }
  }
  .moreInfo {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    @media only screen and (max-width: $lg) {
      flex-direction: column;
    }
    p {
      font-family: 'UniversLTStd-Light';
      font-size: 14px;
    }
    a {
      color: $dark-blue;
      font-family: 'UniversLTStd-Bold';
    }
    .moreInfoLeft {
      padding-right: 25px;
      .blueLine {
        border-bottom: 2px solid $light-blue;
        padding: 10px 0;
      }
      .paymentHeader {
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
        @media only screen and (max-width: $lg) {
          flex-direction: column;
        }
        h2 {
          background-color: $dark-blue;
          color: #fff;
          font-family: 'UniversLTStd-Bold';
          font-size: 18px;
          text-align: center;
          padding: 5px 30px;
          margin: 10px 0;
        }
        p {
          padding-left: 30px;
          position: relative;
          top: 5px;
          span {
            font-family: 'UniversLTStd-Bold';
          }
        }
      }
    }
    .moreInfoRight {
      display: flex;
      justify-content: center;
      width: 90%;
      align-items: center;
      border-left: 2px solid $light-blue;
      padding: 0 25px;
      @media only screen and (max-width: $lg) {
        flex-direction: column;
      }
    }
  }
  .paymentPlan {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
    @media only screen and (max-width: $lg) {
      flex-direction: column;
    }
    .paymentPlanLeft {
      border: 2px solid #bcbec0;
      padding: 25px;
      width: 65%;
      position: relative;
      @media only screen and (max-width: $lg) {
        width: 100%;
      }
      .checkBox {
        position: absolute;
        bottom: 0;
        right: 0;
      }
      p {
        font-family: 'UniversLTStd-Light';
        font-size: 14px;
        margin: 10px 0;
        span {
          font-family: 'UniversLTStd-Bold';
        }
      }
      .paymentPlanLeft-top {
        display: flex;
        justify-content: flex-start;
        @media only screen and (max-width: $lg) {
          flex-direction: column;
        }
        h4 {
          color: $dark-blue;
          font-family: 'UniversLTStd-Bold';
          font-size: 16px;
        }
        p {
          font-family: 'UniversLTStd-Light';
          font-size: 14px;
          margin: 10px 0;
          span {
            font-family: 'UniversLTStd-Bold';
          }
        }
        div:first-child {
          width: 75%;
          padding-right: 25px;
          border-right: 2px solid #bcbec0;
          @media only screen and (max-width: $lg) {
            width: 100%;
            border-right: none;
          }
        }
        div:nth-child(2){
          padding-left: 20px;
          ol {
            padding: 0 0 0 20px;
            margin: 0;
          }
        }
      }
    }
    .paymentPlanRight {
      text-align: center;
      border: 2px solid #bcbec0;
      width: 35%;
      padding: 25px;
      margin-left: 15px;
      position: relative;
      @media only screen and (max-width: $lg) {
        width: 100%;
        margin-left: 0;
      }
      .userField {
        font-size: 20px;
      }
      .checkBox {
        position: absolute;
        bottom: 0;
        right: 0;
      }
      .due {
        font-family: 'UniversLTStd-Light';
        font-size: 12px;
      }
      h4 {
        color: $dark-blue;
        font-family: 'UniversLTStd-Bold';
        font-size: 16px;
        border-bottom: 1px solid #bcbec0;
        padding-bottom: 25px;
        margin-bottom: 25px;
      }
    }
  }
  .paymentOptions {
    border: 2px solid #bcbec0;
    padding: 25px;
    margin-top: 25px;
    display: flex;
    @media only screen and (max-width: $lg) {
      flex-direction: column;
    }
    .paymentOptionsLeft {
      width: 100%;
      padding-right: 50px;
      font-family: 'UniversLTStd-Bold';
      color: #939598;
      .paymentRow {
        display: flex;
        justify-content: space-between;
        .paymentOptionBox {
          text-align: center;
          @media only screen and (max-width: $lg) {
            font-size: 12px;
          }
          div {
            width: 25px;
            height: 25px;
            background-color: #f1f4ff;
            border: 2px solid $dark-blue;
            margin: auto;
          }
        }
        .creditCardInfo {
          width: 100%;
          margin-top: 25px;
          padding-right: 25px;
          .userField {
            border-bottom: 1px solid #000;
            height: 30px;
          }
          .creditCardInfoBottom {
            display: flex;
            margin-top: 25px;
            div:first-child {
              padding-right: 25px;
            }
            .userField {
              width: 100px;
            } 
          }
        }
        .signature {
          width: 100%;
          margin-top: 25px;
          span {
            font-size: 10px;
          }
          .userField {
            height: 30px;
          }
          .signatureBottom {
            display: flex;
            margin-top: 25px;
            div:first-child {
              padding-right: 25px;
            }
            .userField {
              width: 100px;
              border-bottom: 1px solid #000;
            } 
          }
        }
        &.paymentRowFields {
          @media only screen and (max-width: $lg) {
            flex-direction: column;
          }
        }
      }
    }
    .paymentOptionsRight {
      width: 60%;
      @media only screen and (max-width: $lg) {
        width: 100%;
      }
      h2 {
        background-color: $dark-blue;
        color: #fff;
        font-family: 'UniversLTStd-Bold';
        font-size: 18px;
        text-align: center;
        padding: 5px 30px;
        margin: 10px 0;
      }
      p {
        font-family: 'UniversLTStd-Light';
      }
    }
  }
  .finePrint{
    font-family: 'UniversLTStd-Light';
    font-size: 14px;
    margin: 10px 0;
    text-align: center;
  }
}
</style>